import type { SVGProps } from "react";

const DecentralizationLine = ({
  className,
  ...props
}: { className?: string } & SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="115"
      height="112"
      viewBox="0 0 115 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M113.333 111.333C113.886 111.333 114.333 110.886 114.333 110.333C114.333 109.781 113.886 109.333 113.333 109.333V110.333V111.333ZM5.33337 5.33332L5.33338 6.33332L40.8334 6.33328V5.33328L40.8333 4.33328L5.33337 4.33332L5.33337 5.33332ZM60.8334 25.3333H59.8334V90.3332H60.8334H61.8334V25.3333H60.8334ZM80.8334 110.333L80.8333 111.333L113.333 111.333V110.333V109.333L80.8334 109.333V110.333ZM60.8334 90.3332H59.8334C59.8334 101.931 69.2354 111.333 80.8333 111.333L80.8334 110.333V109.333C70.34 109.333 61.8334 100.827 61.8334 90.3332H60.8334ZM40.8334 5.33328V6.33328C51.3268 6.33326 59.8334 14.8399 59.8334 25.3333H60.8334H61.8334C61.8334 13.7353 52.4313 4.33326 40.8333 4.33328L40.8334 5.33328Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default DecentralizationLine;
